import React from 'react';

const LegalTextPage = ({ title, blocks }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-indigo-50 via-white to-indigo-100 px-4 py-10">
      <div className="mx-auto max-w-4xl rounded-2xl border border-indigo-100 bg-white p-6 shadow-lg md:p-8">
        <div className="mb-6 border-b border-indigo-100 pb-4">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-500">Legal</p>
          <h1 className="mt-2 text-3xl font-black text-indigo-900 md:text-4xl">{title}</h1>
        </div>
        <article className="legal-content">
          {blocks.map((block, blockIndex) => {
            if (block.type === 'heading') {
              return <h2 key={`heading-${blockIndex}-${block.text}`}>{block.text}</h2>;
            }

            if (block.type === 'paragraph') {
              return <p key={`paragraph-${blockIndex}-${block.text}`}>{block.text}</p>;
            }

            if (block.type === 'list') {
              return (
                <ul key={`list-${blockIndex}`}>
                  {block.items.map((item, itemIndex) => (
                    <li key={`item-${blockIndex}-${itemIndex}-${item}`}>{item}</li>
                  ))}
                </ul>
              );
            }

            return null;
          })}
        </article>
      </div>
    </div>
  );
};

export default LegalTextPage;
